import { apiClient } from '@shared/api/client';
import { ApiResponse } from '@shared/api/api.types';

/**
 * Subject User Management API
 *
 * Note: Subject info is now fetched via tRPC (trpc.subject.getById).
 * This API only contains user-role operations that work with the /user-roles endpoint.
 */
export const subjectUserManagementApi = {
  /**
   * Remove a user role assignment (calls /user-roles endpoint)
   * The user record remains, only the role association is removed.
   *
   * Note: Parameters _userId, _tenantId, _domainId, _subjectId are kept for
   * backwards compatibility with useRemoveSubjectUser hook signature.
   * Only userRoleId is actually needed by the endpoint.
   */
  async removeSubjectUserRole(
    _userId: string,
    _tenantId: string,
    _domainId: string,
    _subjectId: string,
    userRoleId: string
  ): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`/user-roles/${userRoleId}`);
  },
};

// Export for backwards compatibility
export const subjectApi = {
  subjectUserManagement: subjectUserManagementApi,
};
